import { CSSProperties } from 'react';

import { css, SerializedStyles } from '@emotion/core';

import { Colors } from '../../../../index';
import { ITheme, IUnfoldTheme } from '../../../common/types';

export type TElevation =
  | 'e100'
  | 'e150'
  | 'e200'
  | 'e300'
  | 'e400'
  | 'e500'
  | 'card'
  | 'modal';

export interface IMixinProps {
  theme: ITheme;
  elevation?: TElevation;
}

type TElevationToken = Record<TElevation, CSSProperties>;

export const elevations: IUnfoldTheme<TElevationToken> = {
  dark: {
    e100: {
      backgroundColor: Colors.BLACK,
      boxShadow: 'none',
    },
    e150: {
      backgroundColor: Colors.BLACK,
      boxShadow: 'none',
    },
    e200: {
      backgroundColor: Colors.BLACK,
      boxShadow: 'none',
    },
    e300: {
      backgroundColor: Colors.BLACK,
      boxShadow: 'none',
    },
    e400: {
      backgroundColor: Colors.BLACK,
      boxShadow: 'none',
    },
    e500: {
      backgroundColor: Colors.BLACK,
      boxShadow: 'none',
    },
    card: {
      backgroundColor: Colors.BLACK,
      boxShadow: 'none',
    },
    modal: {
      backgroundColor: Colors.BLACK,
      boxShadow: 'none',
    },
  },
  light: {
    e100: {
      backgroundColor: Colors.WHITE,
      boxShadow: `0 1px 1px ${Colors.BLACK}, 0 0 1px 0 ${Colors.BLACK};`,
    },
    e150: {
      backgroundColor: Colors.WHITE,
      boxShadow: `0 2px 4px -1px ${Colors.BLACK}, 0 0 1px ${Colors.BLACK};`,
    },
    e200: {
      backgroundColor: Colors.WHITE,
      boxShadow: `0 4px 8px -2px ${Colors.BLACK}, 0 0 1px ${Colors.BLACK};`,
    },
    e300: {
      backgroundColor: Colors.WHITE,
      boxShadow: `0 8px 16px -4px ${Colors.BLACK}, 0 0 1px ${Colors.BLACK};`,
    },
    e400: {
      backgroundColor: Colors.WHITE,
      boxShadow: `0 12px 24px -6px ${Colors.BLACK}, 0 0 1px ${Colors.BLACK};`,
    },
    e500: {
      backgroundColor: Colors.WHITE,
      boxShadow: `0 20px 32px -8px ${Colors.BLACK}, 0 0 1px ${Colors.BLACK};`,
    },
    card: {
      backgroundColor: Colors.WHITE,
      boxShadow: `0px 10px 40px #e8e8e8;`,
    },
    modal: {
      backgroundColor: Colors.WHITE,
      boxShadow: `0px 23px 44px rgba(179, 179, 179, 0.5);`,
    },
  },
};

const elevation = ({
  elevation: depth,
  theme,
}: IMixinProps): SerializedStyles =>
  depth
    ? css`
        background-color: ${elevations[theme?.name]?.[depth].backgroundColor};
        box-shadow: ${elevations[theme?.name]?.[depth].boxShadow};
      `
    : css``;

export { elevation };
